import React from 'react';
import { Clickable } from 'src/components/clickable';
import * as S from './styles';

type OwnProps = {
  children: React.ReactNode;
};

type ClickableProps = React.ComponentProps<typeof Clickable>;

type Props = OwnProps & ClickableProps;

export const TextLink = ({ children, ...props }: Props) => (
  <S.TextLink {...props}>{children}</S.TextLink>
);
